import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Link from "@material-ui/core/Link";
import { useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CloseIcon from "@material-ui/icons/Close";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { HELP_SUPPORT_URL } from "../../constants";
import * as chatBubble from "../../static/img/chat_bubble.png";
import * as faq from "../../static/img/FAQ.png";
import { Webchat } from "../webchat/Webchat";
import "./css/contactModal.scss";

interface IParams {
    isOpen: boolean;
    setIsOpen(isOpen: boolean): void;
}

export const ContactModal = (props: IParams) => {
    const { isOpen, setIsOpen } = props;
    const { t } = useTranslation("footer");
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down(740));

    const closeModal = () => setIsOpen(false);

    const letsChat = (
        <Webchat>
            {({ hasAvailableAgent, openChat }) => {
                const onClick = () => {
                    closeModal();
                    openChat();
                };

                return (
                    <Grid className="contact-modal__option" item sm={!fullScreen && 5} xs={12}>
                        {hasAvailableAgent && (
                            <Fragment>
                                <Link color="inherit" href="#" underline="none" onClick={onClick}>
                                    <img alt="chat bubble" className="contact-modal__image" src={chatBubble} />
                                </Link>
                                <Link
                                    className="contact-modal__option-link"
                                    color="inherit"
                                    href="#"
                                    underline="none"
                                    onClick={onClick}
                                >
                                    <Typography color="inherit" variant="subtitle2">
                                        {t("letChat").toLocaleUpperCase()}
                                    </Typography>
                                    <KeyboardArrowRight className="contact-modal__arrow" />
                                </Link>
                            </Fragment>
                        )}
                        {!hasAvailableAgent && (
                            <Typography align="center" color="inherit">
                                {t("chatUnavailable")}
                            </Typography>
                        )}
                    </Grid>
                );
            }}
        </Webchat>
    );

    return (
        <Dialog
            PaperProps={{ className: "contact-modal" }}
            aria-labelledby="dialogTitle"
            fullScreen={fullScreen}
            fullWidth
            maxWidth="xs"
            open={isOpen}
            onClose={closeModal}
        >
            <div className="contact-modal__close">
                <IconButton aria-label="close" className="contact-modal__close-icon" size="small" onClick={closeModal}>
                    <CloseIcon />
                </IconButton>
            </div>
            <Typography className="contact-modal__title" color="inherit" variant="h2">
                {t("needHelp")}
            </Typography>
            <DialogContent className="contact-modal__content">
                <Typography align="center" className="contact-modal__text" color="inherit">
                    {t("contactModalText")}
                </Typography>
                <Grid className="contact-modal__option-wrapper" container justify="space-around">
                    {letsChat}

                    <Grid className="contact-modal__divider" item sm="auto" xs={12}>
                        <Divider orientation={fullScreen ? "horizontal" : "vertical"} variant="middle" />
                    </Grid>

                    <Grid className="contact-modal__option" item sm={!fullScreen && 5} xs={12}>
                        <Link href={HELP_SUPPORT_URL}>
                            <img alt="FAQ" className="contact-modal__image" src={faq} />
                        </Link>
                        <Link
                            className="contact-modal__option-link"
                            color="inherit"
                            href={HELP_SUPPORT_URL}
                            underline="none"
                        >
                            <Typography color="inherit" variant="subtitle2">
                                {t("browseFaq").toLocaleUpperCase()}
                            </Typography>
                            <KeyboardArrowRight className="contact-modal__arrow" />
                        </Link>
                    </Grid>
                    <Grid item xs={12}>
                        <Link
                            className="contact-modal__option--bottom-link"
                            color="inherit"
                            href={HELP_SUPPORT_URL}
                            underline="none"
                        >
                            <Typography align="center" color="inherit">
                                {t("byEmail").toLocaleUpperCase()}
                            </Typography>
                            <KeyboardArrowRight className="contact-modal__arrow" />
                        </Link>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};
